import { render, staticRenderFns } from "./answerOrganizationTicket.vue?vue&type=template&id=f7a63196&"
import script from "./answerOrganizationTicket.vue?vue&type=script&lang=js&"
export * from "./answerOrganizationTicket.vue?vue&type=script&lang=js&"
import style0 from "./answerOrganizationTicket.vue?vue&type=style&index=0&id=f7a63196&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports